import axios from "axios";

const chaseVenue = async ({ venue_id, enquiry_id }, token) => {
  try {
    await axios.post(
      `${window.API}/rfp/chase-venue`,
      {
        enquiry_id,
        venue_id,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return { result: true };
  } catch (error) {
    return { error };
  }
};

export { chaseVenue };
